export const capitalize = (value: unknown) => typeof value !== 'string'
    ? ''
    : value.charAt(0).toUpperCase() + value.slice(1)
